module.exports = __webpack_public_path__ + "static/media/video.b8c91429.svg";